// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-ae {
  margin-top: 12px;
  padding: 14px 14px 16px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(42, 155, 181, 0.28);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(16px);
  color: #f8fafc;
}

.dp-ae__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.dp-ae__kicker {
  margin: 0 0 4px;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #7dd3e8;
  font-weight: 600;
}

.dp-ae__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.dp-ae__schema {
  margin: 4px 0 0;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #93c5fd;
}

.dp-ae__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.dp-ae__pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  background: rgba(148, 163, 184, 0.16);
  color: #cbd5e1;
}

.dp-ae__pill--smart {
  background: rgba(42, 155, 181, 0.22);
  color: #7dd3e8;
}

.dp-ae__objective {
  margin: 8px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #cbd5e1;
}

.dp-ae__video {
  margin-top: 12px;
}

.dp-ae__video-el {
  display: block;
  width: 100%;
  max-height: 240px;
  border-radius: 12px;
  background: #020617;
  object-fit: contain;
}

.dp-ae__video-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
}

.dp-ae__dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.45);
  cursor: pointer;
}

.dp-ae__dot--on {
  background: #2a9bb5;
}

.dp-ae__empty,
.dp-ae__explain {
  margin: 10px 0 0;
  font-size: 0.86rem;
  line-height: 1.45;
  color: #e2e8f0;
}

.dp-ae__explain--muted,
.dp-ae__empty {
  color: #94a3b8;
}

.dp-ae__hr {
  margin-top: 12px;
}

.dp-ae__hr .hr-chart-root--compact .hr-summary-section {
  background: rgba(15, 23, 42, 0.55);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

.dp-ae__zones {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.dp-ae__zone {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  color: #f8fafc;
  background: color-mix(in srgb, var(--z) 28%, transparent);
  border: 1px solid color-mix(in srgb, var(--z) 55%, transparent);
}

.dp-ae__notes {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.dp-ae__note {
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border-left: 3px solid #64748b;
}

.dp-ae__note--coach {
  border-left-color: #3b82f6;
}

.dp-ae__note--sparring {
  border-left-color: #f97316;
}

.dp-ae__note--self {
  border-left-color: #2a9bb5;
}

.dp-ae__note-who {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.dp-ae__note p {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.4;
}

.dp-ae__form {
  margin-top: 14px;
}

.dp-ae__q {
  display: block;
  margin: 10px 0 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #e2e8f0;
}

.dp-ae__rating-row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
}

.dp-ae__rate {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 4px;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(15, 23, 42, 0.45);
  color: #e2e8f0;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), background 0.2s ease;
}

.dp-ae__rate:hover:not(:disabled) {
  transform: scale(1.03);
}

.dp-ae__rate:active:not(:disabled) {
  transform: scale(0.97);
}

.dp-ae__rate:focus-visible {
  outline: 2px solid #7dd3e8;
  outline-offset: 2px;
}

.dp-ae__rate:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.dp-ae__submit {
  width: 100%;
  margin-top: 14px;
  padding: 11px 14px;
  border: 0;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.92rem;
  color: #04151b;
  background: linear-gradient(135deg, #7dd3e8 0%, #2a9bb5 100%);
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.2s ease;
}

.dp-ae__submit:hover:not(:disabled) {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(42, 155, 181, 0.35);
}

.dp-ae__submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.dp-ae__saved {
  margin: 12px 0 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #6ee7b7;
}

@media (max-width: 520px) {
  .dp-ae {
    padding: 12px 10px 14px;
  }

  .dp-ae__video-el {
    max-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AICoach/AutoevalGuideCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,2CAA2C;EAC3C,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,yDAAyD;EACzD,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".dp-ae {\n  margin-top: 12px;\n  padding: 14px 14px 16px;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(42, 155, 181, 0.28);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);\n  backdrop-filter: blur(16px);\n  color: #f8fafc;\n}\n\n.dp-ae__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.dp-ae__kicker {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #7dd3e8;\n  font-weight: 600;\n}\n\n.dp-ae__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.dp-ae__schema {\n  margin: 4px 0 0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #93c5fd;\n}\n\n.dp-ae__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  justify-content: flex-end;\n}\n\n.dp-ae__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: rgba(148, 163, 184, 0.16);\n  color: #cbd5e1;\n}\n\n.dp-ae__pill--smart {\n  background: rgba(42, 155, 181, 0.22);\n  color: #7dd3e8;\n}\n\n.dp-ae__objective {\n  margin: 8px 0 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: #cbd5e1;\n}\n\n.dp-ae__video {\n  margin-top: 12px;\n}\n\n.dp-ae__video-el {\n  display: block;\n  width: 100%;\n  max-height: 240px;\n  border-radius: 12px;\n  background: #020617;\n  object-fit: contain;\n}\n\n.dp-ae__video-dots {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.dp-ae__dot {\n  width: 8px;\n  height: 8px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(148, 163, 184, 0.45);\n  cursor: pointer;\n}\n\n.dp-ae__dot--on {\n  background: #2a9bb5;\n}\n\n.dp-ae__empty,\n.dp-ae__explain {\n  margin: 10px 0 0;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: #e2e8f0;\n}\n\n.dp-ae__explain--muted,\n.dp-ae__empty {\n  color: #94a3b8;\n}\n\n.dp-ae__hr {\n  margin-top: 12px;\n}\n\n.dp-ae__hr .hr-chart-root--compact .hr-summary-section {\n  background: rgba(15, 23, 42, 0.55);\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n}\n\n.dp-ae__zones {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.dp-ae__zone {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 999px;\n  color: #f8fafc;\n  background: color-mix(in srgb, var(--z) 28%, transparent);\n  border: 1px solid color-mix(in srgb, var(--z) 55%, transparent);\n}\n\n.dp-ae__notes {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.dp-ae__note {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border-left: 3px solid #64748b;\n}\n\n.dp-ae__note--coach {\n  border-left-color: #3b82f6;\n}\n\n.dp-ae__note--sparring {\n  border-left-color: #f97316;\n}\n\n.dp-ae__note--self {\n  border-left-color: #2a9bb5;\n}\n\n.dp-ae__note-who {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 4px;\n}\n\n.dp-ae__note p {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.dp-ae__form {\n  margin-top: 14px;\n}\n\n.dp-ae__q {\n  display: block;\n  margin: 10px 0 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #e2e8f0;\n}\n\n.dp-ae__rating-row {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.dp-ae__rate {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 4px;\n  border-radius: 10px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: rgba(15, 23, 42, 0.45);\n  color: #e2e8f0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), background 0.2s ease;\n}\n\n.dp-ae__rate:hover:not(:disabled) {\n  transform: scale(1.03);\n}\n\n.dp-ae__rate:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.dp-ae__rate:focus-visible {\n  outline: 2px solid #7dd3e8;\n  outline-offset: 2px;\n}\n\n.dp-ae__rate:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.dp-ae__submit {\n  width: 100%;\n  margin-top: 14px;\n  padding: 11px 14px;\n  border: 0;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 0.92rem;\n  color: #04151b;\n  background: linear-gradient(135deg, #7dd3e8 0%, #2a9bb5 100%);\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.2s ease;\n}\n\n.dp-ae__submit:hover:not(:disabled) {\n  transform: scale(1.02);\n  box-shadow: 0 8px 20px rgba(42, 155, 181, 0.35);\n}\n\n.dp-ae__submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.dp-ae__saved {\n  margin: 12px 0 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #6ee7b7;\n}\n\n@media (max-width: 520px) {\n  .dp-ae {\n    padding: 12px 10px 14px;\n  }\n\n  .dp-ae__video-el {\n    max-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
